import React from 'react'
import { hot } from 'react-hot-loader'
import { BrowserRouter as Router } from 'react-router-dom'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import Routes from './routes/Routes'
import AnalyticsListener from './firebase/AnalyticsListener'

const supportsHistory = 'pushState' in window.history

const App = () => (
  <Router forceRefresh={!supportsHistory} keyLength={12}>
    <Routes />
    <AnalyticsListener />
  </Router>
)

export default hot(module)(App)
